import type {ReactElement} from 'react';
import React from 'react';
import styles from './color-palettes-loading-skeleton.module.scss';
import {SkeletonBrick} from '@Components/skeleton-brick';
import {getUniqueString} from '@Utils/string.util';

const SKELETON_BRICK_MAX_WIDTH = 252;
const SKELETON_BRICK_WIDTH_PERCENTAGES = [100, 55, 80, 100, 55];
const SKELETON_BRICK_HEIGHT = 24;
const SKELETON_BRICK_RADIUS = '4px';

export function ColorPalettesLoadingSkeleton(): ReactElement {
  return (
    <div className={styles.loadingSkeleton}>
      {SKELETON_BRICK_WIDTH_PERCENTAGES.map((widthPercentage) => {
        return <SkeletonBrick key={getUniqueString()} width={SKELETON_BRICK_MAX_WIDTH * (widthPercentage / 100)} height={SKELETON_BRICK_HEIGHT} radius={SKELETON_BRICK_RADIUS} />;
      })}
    </div>
  );
}
